import { add, append, set, update } from '@/vuex/helpers';
import baseURLv1 from '@/services/APIConfig';

export default {
  namespaced: true,
  state: {
    isMessagingMetricsByUserLoading: true,
    messagingMetricsByUser: [],
    messageResponseTime: {},
    messagingMetricsFilters: {
      order_by: '',
      date_from: '',
      date_to: '',
      client_company: '',
      page_size: 100,
    },
    isPermitStatusMetricsByUserLoading: true,
    permitStatusMetricsByUser: [],
    permitStatusTotalMetrics: {},
    permitStatusMetricsFilters: {
      order_by: '',
      date_from: '',
      date_to: '',
      client_company: '',
      page_size: 100,
    },
    isPermitActionDatesMetricsByUserLoading: true,
    permitActionDatesMetricsByUser: [],
    permitActionDatesTotalMetrics: {},
    permitActionDatesMetricsFilters: {
      order_by: '',
      date_from: '',
      date_to: '',
      client_company: '',
      page_size: 100,
    },
    isDocumentMetricsByUserLoading: true,
    documentMetricsByUser: [],
    documentResponseTime: {},
    documentMetricsFilters: {
      order_by: '',
      date_from: '',
      date_to: '',
      client_company: '',
      page_size: 100,
    },
    isPermitIssueMetricsByUserLoading: true,
    permitIssueMetricsByUser: [],
    permitIssueResponseTime: {},
    permitIssueMetricsFilters: {
      order_by: '',
      date_from: '',
      date_to: '',
      client_company: '',
      page_size: 100,
    },
  },
  mutations: {
    set,
    update,
    add,
    append,

    sortMessagingMetricsByUser(state, { field, payload }) {
      state.messagingMetricsFilters[field] = payload;
    },

    sortPermitStatusMetricsByUser(state, { field, payload }) {
      state.permitStatusMetricsFilters[field] = payload;
    },

    sortPermitActionDatesMetricsByUser(state, { field, payload }) {
      state.permitActionDatesMetricsFilters[field] = payload;
    },

    sortDocumentMetricsByUser(state, { field, payload }) {
      state.documentMetricsFilters[field] = payload;
    },

    sortPermitIssueMetricsByUser(state, { field, payload }) {
      state.permitIssueMetricsFilters[field] = payload;
    },

    updateFilter(state, { metricType, field, payload }) {
      state[metricType][field] = payload;
    },
  },
  actions: {
    async loadMessagingUsersMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.messagingMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/message-response-time/?${queryParams.toString()}`);

      commit('set', ['messagingMetricsByUser', response.data.data]);
      commit('set', ['isMessagingMetricsByUserLoading', false]);
    },
    async loadMessagingAverageMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.messagingMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/message-response-time/overall-avg?${queryParams.toString()}`);

      commit('set', ['messageResponseTime', response.data.data]);
    },
    async loadPermitStatusMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.permitStatusMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/permit-status-fulfillment/?${queryParams.toString()}`);

      commit('set', ['permitStatusMetricsByUser', response.data.data]);
      commit('set', ['isPermitStatusMetricsByUserLoading', false]);
    },
    async loadPermitStatusAverageMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.permitStatusMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/permit-status-fulfillment/funnel/?${queryParams.toString()}`);
      const permitStatusTotalMetrics = response.data.data;

      commit('set', ['permitStatusTotalMetrics', permitStatusTotalMetrics]);
    },
    async loadPermitActionDatesMetrics({ state,  commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.permitActionDatesMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/permit-action-date-fulfillment/?${queryParams.toString()}`);

      commit('set', ['permitActionDatesMetricsByUser', response.data.data]);
      commit('set', ['isPermitActionDatesMetricsByUserLoading', false]);
    },
    async loadPermitActionDateAverageMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.permitActionDatesMetricsFilters).forEach(([key, value]) => {
        if (key !== 'order_by' && value ) {
          queryParams.append(key, value);
        }
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/permit-action-date-fulfillment/funnel/?${queryParams.toString()}`);
      console.log('Permit action date average metrics response:', response);
      const permitActionDatesTotalMetrics = response.data.data;

      commit('set', ['permitActionDatesTotalMetrics', permitActionDatesTotalMetrics]);
    },
    async loadDocumentUsersMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.documentMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/document-response-time/?${queryParams.toString()}`);

      commit('set', ['documentMetricsByUser', response.data.data]);
      commit('set', ['isDocumentMetricsByUserLoading', false]);
    },
    async loadDocumentAverageMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.documentMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/document-response-time/overall-avg?${queryParams.toString()}`);

      commit('set', ['documentResponseTime', response.data.data]);
    },
    async loadPermitIssueUsersMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.permitIssueMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/permit-issue-time/?${queryParams.toString()}`);

      commit('set', ['permitIssueMetricsByUser', response.data.data]);
      commit('set', ['isPermitIssueMetricsByUserLoading', false]);
    },
    async loadPermitIssueAverageMetrics({ state, commit }) {
      const queryParams = new URLSearchParams();
      Object.entries(state.permitIssueMetricsFilters).forEach(([key, value]) => {
        queryParams.append(key, value);
      });
      const response = await this.$axios.get(`${baseURLv1}/dashboard/metrics/permit-issue-time/overall-avg?${queryParams.toString()}`);

      commit('set', ['permitIssueResponseTime', response.data.data]);
    },
  },
};
